import React from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
//Pages
import Home from "./pages/home";
import Spotlight from "./pages/spotlight";
import ArtOfFacingChallenges from "./pages/artOfFacingChallenges";
import NotFound from "./pages/notFound";
//components
import Header from "./components/header";
//Styles
import "./App.scss";

function App() {
  const imageDetails = {
    width: 524,
    height: 650,
  };

  return (
    <Router>
      <Header />
      <Route
        render={({ location }) => (
          <AnimatePresence initial={false} mode="wait">
            <Switch location={location} key={location.pathname}>
              <Route
                exact
                path="/"
                render={() => <Home imageDetails={imageDetails} />}
              />
              <Route
                exact
                path="/spotlight"
                render={() => <Spotlight imageDetails={imageDetails} />}
              />
              <Route
                exact
                path="/the-art-of-facing-challenges"
                render={() => <ArtOfFacingChallenges />}
              />
              <Route path="*" render={() => <NotFound />} />
            </Switch>
          </AnimatePresence>
        )}
      />
    </Router>
  );
}

export default App;
